if (document.querySelector("body").classList.contains("home")) {
    const newsInner = document.querySelectorAll(".mv__newsInner")

    const changeNews = (bool, elm, btns) => {
        const now = elm.querySelector("article>a.is-on")

        const doChange = (next) => {
            if (next !== null) {
                now.classList.remove("is-on")
                next.classList.add("is-on")

                if (next.previousElementSibling === null) {
                    btns[0].classList.add("disabled")
                } else {
                    btns[0].classList.remove("disabled")
                }

                if (next.nextElementSibling === null) {
                    btns[1].classList.add("disabled")
                } else {
                    btns[1].classList.remove("disabled")
                }
            }
        }

        if (bool) {
            let next = now.previousElementSibling
            doChange(next)
        } else {
            let next = now.nextElementSibling
            doChange(next)
        }
    }

    newsInner.forEach((newsIn) => {
        const btns = newsIn.querySelectorAll(".mv__newsInnerBtn>span")
        btns[0].addEventListener("click", () => {
            changeNews(true, newsIn, btns)
        })
        btns[1].addEventListener("click", () => {
            changeNews(false, newsIn, btns)
        })
    })
}